import {RsAddressCandidate} from "./dto/RsAddressCandidate";
import {AxiosResponse} from "axios";
import {Response} from "./dto/Response"
import {RsExternalAddress} from "./dto/RsExternalAddress";
import apiJson from "../config/api-json";

export class AddressAPI {

    baseUrl = "/address"

    async search(query: string, verificationId: string): Promise<RsAddressCandidate[]> {
        let token = localStorage.getItem("next-step")
        const config = {
            headers: {
                'x-api-key': token,
                'vid': verificationId
            }
        }
        const response: AxiosResponse<Response<RsAddressCandidate[]>> = await apiJson.get(`${this.baseUrl}/search?query=${query}`, config)
        if (response.status === 200) {
            return response.data.data
        }
        throw new Error(response.statusText)
    }

    async getExternalAddress(id: number, verificationId: string): Promise<RsExternalAddress> {
        let token = localStorage.getItem("next-step")
        const config = {
            headers: {
                'x-api-key': token,
                'vid': verificationId
            }
        }
        const response: AxiosResponse<Response<RsExternalAddress>> = await apiJson.get(`${this.baseUrl}/external/${id}`, config)
        if (response.status === 200) {
            return response.data.data
        }
        throw new Error(response.statusText)
    }

}